import React from 'react';
import { motion } from 'framer-motion';

const clientLogos = [
  "https://static.wixstatic.com/media/89dc71_4486f4967c8845b5aa56ce87056d3fcb~mv2.png/v1/crop/x_40,y_43,w_324,h_124/fill/w_184,h_76,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202026-02-08%20at%202_00_04%E2%80%AFPM.png",
  "https://static.wixstatic.com/media/89dc71_4a606b574f774fdab8d480129a7349be~mv2.png/v1/crop/x_76,y_33,w_430,h_149/fill/w_191,h_70,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202026-02-08%20at%201_58_03%E2%80%AFPM.png",
  "https://static.wixstatic.com/media/89dc71_1ea4ccb2e0d1460e882317392ed87088~mv2.png/v1/fill/w_196,h_82,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-12-28%20at%2010_12_05%E2%80%AFPM.png",
  "https://static.wixstatic.com/media/89dc71_f3dc5837e6d54a24b81f1a54083e5cd1~mv2.png/v1/fill/w_196,h_89,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-12-27%20at%203_26_52%E2%80%AFPM.png",
  "https://static.wixstatic.com/media/89dc71_bd2e08da586e4e47a0ed95700ff8e51d~mv2.jpeg/v1/fill/w_135,h_123,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/hhh.jpeg",
  "https://static.wixstatic.com/media/89dc71_d09f4fefa5fa46a5b6551f693caa4661~mv2.png/v1/fill/w_191,h_76,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202026-02-08%20at%201_57_55%E2%80%AFPM.png"
];

const Clients = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] }
    }
  };

  return (
    <section className="bg-slate-50 py-32 px-8 md:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center mb-20"
        >
          <div className="flex items-center gap-4 mb-6">
            <div className="h-[1px] w-12 bg-[#0c3754]/20" />
            <span className="text-[10px] uppercase tracking-[0.4em] text-[#0c3754] font-bold">
              Partners in Success
            </span>
            <div className="h-[1px] w-12 bg-[#0c3754]/20" />
          </div>
          <h2 className="text-4xl md:text-5xl font-serif text-[#0c3754] text-center leading-tight">
            Trusted By <span className="italic opacity-40">Industry</span> Leaders
          </h2>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8"
        >
          {clientLogos.map((logo, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="group flex items-center justify-center p-8 md:p-12 bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-[0_20px_40px_-20px_rgba(12,55,84,0.15)] hover:-translate-y-2 transition-all duration-500"
            >
              <img
                src={logo}
                alt={`Client ${index + 1}`}
                // Removed grayscale and opacity-40 to keep them in full color
                className="max-h-16 md:max-h-20 max-w-full object-contain transition-all duration-700 ease-out scale-100 group-hover:scale-110"
              />
            </motion.div>
          ))}
        </motion.div>
        
      </div>
    </section>
  );
};

export default Clients;